export default {
  title: 'Developers',
  subtitle: 'API keys, webhooks and delivery history for your Partner API integration.',
  no_account: 'No Partner API account yet — contact Foodamigos to get one provisioned.',
  no_account_manage: 'No Partner API account yet — create one to start issuing keys.',
  buttons: {
    new_account: 'New account',
    edit_account: 'Edit account',
    docs: 'API documentation',
  },
  tabs: {
    api_keys: 'API keys',
    webhooks: 'Webhooks',
    deliveries: 'Deliveries',
  },
  toasts: {
    load_error: 'Could not load your Partner API accounts.',
  },
};
